export default __webpack_public_path__ + "static/media/67.dea6457e.jpeg";